/**
 * Stable React context instance for foundation paste import.
 * Kept in a separate module so Vite HMR does not recreate createContext() while
 * layout/components still hold a stale hook reference.
 */

import { createContext } from 'react'
import type { FoundationPasteImportProgress } from '@/services/persuasion-lab/foundation-paste-import'

export type PasteImportTab = 'guide' | 'paste' | 'options' | 'progress'

export type FoundationPasteImportContextValue = {
    isOpen: boolean
    openModal: (tab?: PasteImportTab) => void
    closeModal: () => void
    initialTab: PasteImportTab
    progress: FoundationPasteImportProgress | null
    jobId: string | null
    estimatedCredits: number | null
    setImportSession: (
        jobId: string,
        progress: FoundationPasteImportProgress,
        estimatedCredits?: number | null
    ) => void
    updateProgress: (progress: FoundationPasteImportProgress) => void
    dismissBanner: () => void
    isImportActive: boolean
    showBanner: boolean
    syncFromRunMetadata: (run: { metadata?: { foundation_paste_import?: FoundationPasteImportProgress } } | null) => void
    clearImportSession: () => Promise<void>
    recoverStuckImport: () => Promise<void>
}

export const FoundationPasteImportContext = createContext<FoundationPasteImportContextValue | null>(null)

export function isActivePasteImportStatus(status?: FoundationPasteImportProgress['status']): boolean {
    return status === 'queued' || status === 'running'
}
